<template>
  <fieldset class="schedule-fieldset">
    <legend>Schedule*</legend>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-3">Start date/time of boost</div>
      <div class="col-md-4">
        <DatePicker required />
      </div>
      <div class="col-md-1 text-end">Time:</div>
      <div class="col-md-2">
        <input
          type="time"
          id="view-counter"
          name="budget"
          placeholder="0.00"
          class="text-end"
        />
      </div>
    </div>
  </fieldset>
</template>

<script>
import DatePicker from "@/components/DatePicker";

export default {
  components: {
    DatePicker,
  },
};
</script>

<style lang="scss" scoped>
.schedule-fieldset {
  #view-counter {
    background-color: white;
    padding: 5%;
  }
}
</style>